export interface AccountSummary {
  accountID: number;
  favorite: boolean;
  accountName: string;
  displayName?: string;
  stockTicker: string;
  stockExchange: string;
  ownershipType: string;
  parentCompany: string;
  parentCompanyID: string;
  topLevelIndustry: string;
  sicDescription: string;
  industryName: string;
  epicLookupCode: string;
  coverageTypes: string;
  attributes: string;
  parentAccountID?: number;
  domainName?: string;
  noDomain: boolean;
  agencies?: string;
  currentPoliciesCount: number;
  inForcePremium?: number;
  revenue: number;
  insertedDate: string;
  fortuneRank?: number;
}

export interface AccountInfo {
  accountID: number;
  accountName: string;
  isParent: boolean;
}

export interface ClientAccount {
  accountID: number;
  accountName: string;
  accountDisplayName?: string;
  accountStatus: string;
  childAccountID?: number | null;
  childAccountName?: string | null;
  childAccountDisplayName?: string | null;
  coverageTypes: string;
  childCoverageTypes: string;
}

export interface AccountServicingRole {
  name: string;
  servicingRoleTitle: string;
  isPublishedOnSomePolicies: boolean;
  isUnpublishedOnSomePolicies: boolean;
}

export const accountSummaryWarnings = (account: AccountSummary): string[] => {
  const warnings: string[] = [];
  if (!account.ownershipType) {
    warnings.push('This account is missing an ownership type.');
  }
  if (!account.sicDescription) {
    warnings.push('This account is missing an industry.');
  }
  if (!account.noDomain && !account.domainName) {
    warnings.push('This account is missing a domain name.');
  }
  if (account.ownershipType === 'Public' && !account?.stockTicker) {
    warnings.push('This account is missing a stock ticker.');
  }
  return warnings;
};

type filterKeys = 'accountName' | 'parentCompany' | 'topLevelIndustry' | 'coverageTypeStr' | 'sicDescription' | 'attributes';

export const accountSummarySearchFilter =
  (searchValue: string) =>
  (account: Record<filterKeys, string | undefined | null>): boolean => {
    if (!searchValue) {
      return true;
    }
    const text = searchValue.toLowerCase();
    return (
      (account.accountName || '').toLowerCase().includes(text) ||
      (account.parentCompany || '').toLowerCase().includes(text) ||
      (account.topLevelIndustry || '').toLowerCase().includes(text) ||
      (account.coverageTypeStr || '').toLowerCase().includes(text) ||
      (account.sicDescription || '').toLowerCase().includes(text) ||
      (account.attributes || '').toLowerCase().includes(text)
    );
  };
